(function() {
    const quiz = document.querySelector('.quiz');
    const answers = document.querySelectorAll('.quiz-answer');

    function renderResult(result, description) {
        if (quiz.querySelector('.quiz-result')) {
            quiz.querySelector('.quiz-result').remove();
        }

        let resultEl = document.createElement('div');

        resultEl.className = 'quiz-result';

        resultEl.innerHTML = `<div>Result</div><span>${result}</span>`;
        if (description) {
            resultEl.innerHTML += `<p>${description}</p>`;
        }

        quiz.appendChild(resultEl);
    };

    function calculateSimpleQuizResult() {
        if (quiz.querySelectorAll('.quiz-question:not(.answered)').length != 0) {
            return;
        }

        let total = 0;
        let correct = 0;

        quiz.querySelectorAll('.quiz-question.answered').forEach((question) => {
            if (question.querySelector('.quiz-answer.quiz-answer-correct.answered') !== null) {
                correct += 1;
            }

            total += 1;
        });

        let description = null;

        if (correct / total >= 0.8) {
            description = 'Brilliant! Your knowledge marks you as a true expert.';
        }else if (correct / total >= 0.5) {
            description = 'Good job! You have a decent understanding with room to grow.';
        }else {
            description = 'Time for a refresher – revisit the movies and books to boost your knowledge!';
        }

        renderResult(`${correct}/${total}`, description);

        sa_event('quiz_passed');
    };

    function calculateStatQuizResult() {
        if (quiz.querySelectorAll('.quiz-question:not(.answered)').length != 0) {
            return;
        }

        const quizSlug = quiz.getAttribute('data-quiz-slug');

        let answers = {};

        quiz.querySelectorAll('.quiz-question.answered').forEach((question) => {
            answers[question.getAttribute('data-question')] = question.querySelector('.quiz-answer.answered').getAttribute('data-answer');
        });


        var xhr = new XMLHttpRequest();

        xhr.open('POST', `/api/quiz/${quizSlug}/`, true);
        xhr.setRequestHeader('Content-Type', 'application/json');

        xhr.onreadystatechange = function() {
            if (xhr.readyState === 4 && xhr.status === 200) {
                var data = JSON.parse(xhr.responseText);

                renderResult(data.result);
            }
        };

        xhr.send(JSON.stringify(answers));

        sa_event('quiz_passed');
    };

    answers.forEach(function (answer) {
        answer.addEventListener('click', function () {
            const question = answer.closest('.quiz-question');

            if (!question.classList.contains('answered')) {
                question.classList.add('answered');
                answer.classList.add('answered');
            }

            if (quiz.querySelectorAll('.quiz-question.answered').length == 1) {
                sa_event('first_answer');
            }

            if (quiz.classList.contains('simple-quiz')) {
                calculateSimpleQuizResult();
            }

            if (quiz.classList.contains('stat-quiz')) {
                calculateStatQuizResult();
            }
        });
    });
}());

(function() {
    const FIRST_NAMES = ['Alaric', 'Beatrix', 'Cedrella', 'Delphina', 'Emeric', 'Fenella', 'Gideon', 'Honoria', 'Ignatius', 'Jocunda', 'Keturah', 'Lysander', 'Mafalda', 'Norvel', 'Orla', 'Perenelle', 'Quintus', 'Rosalind', 'Simeon', 'Tansy', 'Ulysses', 'Vindictus', 'Wendelin', 'Xenophilius', 'Yolanda', 'Zacharias', 'Artemis', 'Belvina', 'Callidora', 'Dorcas', 'Elphias', 'Fortescue', 'Galatea', 'Hengist', 'Isla', 'Joaquin', 'Kirley', 'Lorcan', 'Merope', 'Nigellus', 'Octavius', 'Penelope', 'Quirinus', 'Rowena', 'Sturgis', 'Theophilus', 'Uriah', 'Viridian', 'Wilkie', 'Xenon'];
    const LAST_NAMES = ['Blackwood', 'Clearwater', 'Dewhurst', 'Evergreen', 'Fawley', 'Goldfinch', 'Hawkworth', 'Ironwood', 'Jettstream', 'Kettleburn', 'Longbottom', 'Moonshine', 'Nightshade', 'Oakenshield', 'Puddlefoot', 'Quillworthy', 'Rookwood', 'Shacklebolt', 'Tanglewood', 'Umberfield', 'Vane', 'Willowbend', 'Xanthis', 'Yewbeam', 'Zabini', 'Ashwood', 'Bumblebee', 'Cobblestone', 'Dragonheart', 'Eldergrove', 'Fiddlestick', 'Greengrass', 'Hogsmeade', 'Inkwell', 'Jigger', 'Knotgrass', 'Leek', 'Moonbeam', 'Nettlebed', 'Ollivander', 'Pottersby', 'Quickspell', 'Rune', 'Spinnet', 'Twillfit', 'Underhill', 'Vablatsky', 'Whisperwind', 'Yaxley', 'Zonko'];

    const button = document.querySelector('.name-generator button');

    if (button) {
        button.addEventListener('click', generate);

        function generate() {
            const firstName = FIRST_NAMES[Math.floor(Math.random() * FIRST_NAMES.length)];
            const lastName = LAST_NAMES[Math.floor(Math.random() * LAST_NAMES.length)];

            document.getElementById('generated-name').innerHTML = firstName + ' ' + lastName;
        };

        generate();
    }
}());

(function() {
    const PRODUCTS_ENABLED = false;

    if (!PRODUCTS_ENABLED) {
        return;
    }

    function sampleSize(arr, n) {
        let m = arr.length;

        while (m) {
            const i = Math.floor(Math.random() * m--);
            [arr[m], arr[i]] = [arr[i], arr[m]];
        }

        return arr.slice(0, n);
    };

    var xhr = new XMLHttpRequest();

    xhr.open('GET', 'https://harrypotterquiz.world/assets/built/products.json', true);

    xhr.onreadystatechange = function() {
        if (xhr.readyState === 4 && xhr.status === 200) {
            let data = JSON.parse(xhr.responseText);

            function getProductsHTML(products) {
                let content = '';

                products.forEach((product) => {
                    content += `
                        <a target="_blank" href="${product.url}" class="product" data-product-id="${product.id}">
                            <div class="product-preview">
                                <img src="${product.image}" alt="${product.name}" />
                            </div>
                            <div class="product-name">${product.name}</div>
                            <div class="product-price">${product.price.split('.')[0]}<span>${product.price.split('.')[1]}</span></div>
                            <div class="product-button">Buy Now</div>
                        </a>
                    `;
                });

                return content;
            }

            document.getElementById('products-list').innerHTML = getProductsHTML(data);

            const quizzes = document.getElementsByClassName('quiz');

            if (quizzes.length !== 0) {
                for (const quiz of quizzes) {
                    const container = document.createElement('div');
                    container.classList.add('embedded-products-list');

                    const header = document.createElement('h3');
                    header.innerHTML = 'Store';

                    const productsList = document.createElement('div');
                    productsList.classList.add('products-list');
                    productsList.innerHTML = getProductsHTML(sampleSize(data, 6));

                    container.appendChild(header);
                    container.appendChild(productsList);

                    quiz.getElementsByClassName('quiz-question')[2].after(container);
                }
            }

            const links = document.querySelectorAll('a.product');

            links.forEach(function (link) {
                link.addEventListener('click', function () {
                    sa_event('product_click', { 'product_id': link.dataset.productId });
                });
            });
        }
    };

    xhr.send();
}());
